import React from 'react';
import { Button, ColorPicker, Form, Space, message } from 'antd';
import { applyBranding, DEFAULT_ACCENT, DEFAULT_PRIMARY } from '../../utils/branding';
import { useUpdateBrandingMutation } from '../../queries/me';
import { Card, CardHead } from '../../components';

const hexOf = (v) => (typeof v === 'string' ? v : v?.toHexString?.());

export default function BrandingCard({ branding = {} }) {
  const { mutate, isPending } = useUpdateBrandingMutation();

  const save = (v) => {
    const payload = { primaryColor: hexOf(v.primaryColor), accentColor: hexOf(v.accentColor) };
    mutate(payload, {
      onSuccess: (res) => {
        applyBranding(res.branding || payload);
        message.success('Brand colors saved');
      },
      onError: (err) => message.error(err.response?.data?.message || 'Failed to save')
    });
  };

  return (
    <Card aria-labelledby="brand-title">
      <CardHead>
        <h2 id="brand-title">Brand colors</h2>
        <span>top bar gradient and accent line</span>
      </CardHead>
      <Form
        layout="vertical"
        onFinish={save}
        initialValues={{
          primaryColor: branding.primaryColor || DEFAULT_PRIMARY,
          accentColor: branding.accentColor || DEFAULT_ACCENT
        }}
      >
        <Space size={48} wrap align="start">
          <Form.Item name="primaryColor" label="Main color">
            <ColorPicker format="hex" showText />
          </Form.Item>
          <Form.Item name="accentColor" label="Accent color">
            <ColorPicker format="hex" showText />
          </Form.Item>
        </Space>
        <div>
          <Button type="primary" htmlType="submit" loading={isPending}>
            Save colors
          </Button>
        </div>
      </Form>
    </Card>
  );
}
